// src/components/Login.jsx
import React, { useState } from 'react';
import Logo from './Logo';

const Login = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
        // We use a simple GET request to an auth endpoint for the initial check
        const response = await fetch(`/auth?password=${encodeURIComponent(password)}`);
        if (response.ok) {
            onLoginSuccess(password);
        } else {
            setError('Incorrect password. Please try again.');
        }
    } catch (err) {
        setError('Server is not reachable. Please check your connection.');
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-light">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg">
        <div className="text-center">
          <Logo className="w-20 h-20 mx-auto mb-4" />
          <h1 className="text-4xl font-display font-bold text-brand-dark">Shared Canvas</h1>
          <p className="text-gray-500 mt-2">Your real-time clipboard across all sessions.</p>
        </div>
        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
          <div>
            <label htmlFor="password" className="sr-only">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="appearance-none rounded-md relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-brand-dark focus:outline-none focus:ring-brand-indigo focus:border-brand-indigo focus:z-10 sm:text-sm"
              placeholder="Enter Access Key"
            />
          </div>
          {error && <p className="text-red-500 text-sm text-center">{error}</p>}
          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-brand-indigo hover:bg-brand-indigo-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-indigo disabled:bg-indigo-300"
            >
              {isLoading ? 'Unlocking...' : 'Unlock'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;